import { FunctionComponent, h, Fragment } from "preact"

import { BsFileEarmarkArrowDown } from "react-icons/bs"
import { Button } from "../../parts/buttons"
import Container from "../../parts/container"
import Pagination from "../../components/pagination"
import TopBar from "../../components/topbar"
import TopFilter from "../../components/TopFilter"
import { alertsToExcel } from "./toexcel"
import moment from "moment"
import useAlerts from "../../hooks/useAlerts"
import usePagination from "../../hooks/usePagination"
import useTopFilter from "../../hooks/useTopFilter"
import { useState } from "preact/hooks"
import useObjectState from "../../hooks/useObjectState"
import useMills from "../../hooks/useMills"
import useCems from "../../hooks/useCems"
import Renderif from "../../components/Renderif";
import Loading from "../../components/loading";

type RecordErrorLogPageProps = h.JSX.HTMLAttributes<HTMLDivElement>

const RecordErrorLogPage: FunctionComponent<RecordErrorLogPageProps> = () => {
  const filter = useTopFilter()
  const [selected, setSelected] = useObjectState({
    mil: "",
    cems: "",
  })

  // const [loading, setLoading] = useState(false);


  const { data: mills } = useMills()
  const { data: cems } = useCems()

  const { data: alerts, isLoading } = useAlerts(filter.output)
  const filteredAlerts = alerts
    ?.filter((alert) => !selected.mil || alert.mil?.uuid == selected.mil)
    ?.filter((alert) => !selected.cems || alert.cem?.uuid == selected.cems)

  if (selected.mil!=null) {
    cems?.filter(({ mil }) => mil.uuid == selected.mil || !selected.mil)
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((cem) => (
      selected.cems = cem.uuid
      ))
  // console.log(selected.cems)
    
  }
  const pageHook = usePagination({ count: alerts?.length || 0, step: 20 })
  // console.log("test",selected.mil)
  // const filteredAlerts = null
  // if(selected.mil==null){
  //  filteredAlerts = alerts
  // }
  // else{
  //   filteredAlerts = alerts
  //   ?.filter((alert) => !selected.mil || alert.mil?.uuid == selected.mil)
  //   ?.filter((alert) => !selected.cems || alert.cem?.uuid == selected.cems)

  // }
  

  const handleExport = () => {
    if (filteredAlerts) {
      alertsToExcel(filteredAlerts)
    }
  }

  

  return (
    <div className="min-vh-100">
      <TopBar title="SPARING" subtitle="Records Alert Log">
        <TopFilter hook={filter} />
      </TopBar>
      <Container>
        <div className="card">
          <div className="card-title">
            <h3>Alert Log</h3>
          </div>

          <div className="px-4 py-1 d-flex justify-content-between">
            <div className="d-flex mb-3">
              <select
                placeholder="Select Mills"
                value={selected.mil}
                onChange={(e) => setSelected({ mil: e.currentTarget.value, cems: "" })}
                className="me-2 w-auto form-select rounded-pill"
              >
                {mills && mills?.length ? (
                  mills?.map(({ uuid, name }, idx) => {
                    return (
                      <Fragment>
                        {idx == 0 && <option value="">Select Mills</option>}
                        <option key={uuid} value={uuid}>
                          {name}
                        </option>
                      </Fragment>
                    )
                  })
                ) : (
                  <option value="">No Mills Data</option>
                )}
              </select>
              {/* <select
                value={selected.cems}
                onChange={({ currentTarget }) => setSelected({ cems: currentTarget.value })}
                className="w-auto form-select rounded-pill"
              >
                <option value="">Select CEMS</option>
                {cems
                  ?.filter(({ mil }) => mil.uuid == selected.mil || !selected.mil)
                  ?.sort((a, b) => a.name.localeCompare(b.name))
                  ?.map((cem) => (
                    <option key={cem.uuid} value={cem.uuid}>
                      {cem.name}
                    </option>
                  ))}
              </select> */}
            </div>
            <div>
              {alerts && (
                <Button variant="primary" onClick={handleExport} icon={BsFileEarmarkArrowDown}>
                  Export
                </Button>
              )}
            </div>
          </div>
          <div className="card-body">
            <table className="table table-striped table-data table-center">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Mills</th>
                  <th>Unit</th>
                  <th>Activity</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <Renderif isTrue={isLoading}>
                  <tr className="text-center">
                    <td colSpan={6} className="text-center">
                      <Loading />
                    </td>
                  </tr>
                </Renderif>
                <Renderif isTrue={!isLoading}>
                {filteredAlerts?.length ? (
                  filteredAlerts
                    ?.slice(pageHook.output, pageHook.output + pageHook.step)
                    ?.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
                    ?.map((alert, idx) => (
                      <tr key={"alert-" + idx}>
                        <td>{moment(alert.created_at).format("DD.MM.YYYY")}</td>
                        <td>{moment(alert.created_at).format("HH:mm")}</td>
                        <td>{alert?.mil?.name}</td>
                        <td>{alert?.cem?.name}</td>
                        <td>
                          {alert?.activity
                            ?.replace("cems", "unit")    
                          }
                        </td>
                        <td>
                          {alert?.description
                            ?.replace("sensor name", alert?.cem?.name + "," || "")
                            ?.replace("lower_threshold", "")
                            ?.replace("upper_threshold", "")
                            ?.replace("value", "")
                            ?.replace("}", "")
                            ?.replace(/\d+\.\d{2,}/g, (a) => Number(a).toFixed(2))
                            ?.replace(/\,\s*0$/g, "")}
                        </td>
                      </tr>
                    ))
                ) 
                : !selected.mil?
                  <tr>
                    <td colSpan={6} className="text-center">
                      Select Mils
                    </td>
                  </tr>
                : (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No data.
                    </td>
                  </tr>
                )}
                </Renderif>
              </tbody>
            </table>
            <div className="d-flex justify-content-end">
              <Pagination hook={pageHook} />
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default RecordErrorLogPage
